/**
 * SEO 配置 - chat (العربية)
 */

export default {
    chat: {
        title: 'دردشة الذكاء الاصطناعي - مساعد متعدد النماذج | WeryAI',
        description:
            'تحدث مع أفضل نماذج الذكاء الاصطناعي على WeryAI. قارن الردود جنبًا إلى جنب في نوافذ متعددة. أنشئ صورًا ومقاطع فيديو وموسيقى من مساحة عمل واحدة.',
        keywords:
            'دردشة ذكاء اصطناعي, مساعد ذكاء اصطناعي, دردشة متعددة النماذج, روبوت دردشة, مقارنة نماذج الذكاء الاصطناعي, بديل GPT, مساحة عمل ذكاء اصطناعي, WeryAI',
        og_title: 'دردشة الذكاء الاصطناعي - مساعد متعدد النماذج | WeryAI',
        og_description:
            'تحدث مع أفضل نماذج الذكاء الاصطناعي وقارن الردود جنبًا إلى جنب. أنشئ صورًا ومقاطع فيديو والمزيد. جرّب مجانًا على WeryAI.',
        twitter_title: 'دردشة الذكاء الاصطناعي - مساعد متعدد النماذج | WeryAI',
        twitter_description:
            'تحدث مع أفضل نماذج الذكاء الاصطناعي وقارن الردود جنبًا إلى جنب. أنشئ صورًا ومقاطع فيديو والمزيد. جرّب مجانًا على WeryAI.',
    },
}
